import React from 'react';

const Spinner = () => {
    return (
        <svg
            id="prefix__e9cb74oucte1"
            width={30}
            height={30}
            viewBox="0 0 234 240"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
        >
            <style>
                {
                    '@keyframes e9cb74oucte3_to__to{0%{transform:translate(125.706391px,125.414005px);animation-timing-function:cubic-bezier(.63,.245,.455,.985)}44%,57%{transform:translate(119.621283px,127.596983px);animation-timing-function:cubic-bezier(.63,.245,.455,.985)}to{transform:translate(125.706391px,125.414005px)}}@keyframes e9cb74oucte3_tr__tr{0%{transform:rotate(0deg);animation-timing-function:cubic-bezier(.63,.245,.455,.985)}to{transform:rotate(360deg)}}@keyframes e9cb74oucte5_to__to{0%{transform:translate(109.012761px,122.577737px);animation-timing-function:cubic-bezier(.63,.245,.455,.985)}44%,57%{transform:translate(117px,128.251473px);animation-timing-function:cubic-bezier(.63,.245,.455,.985)}to{transform:translate(109.012761px,122.577737px)}}@keyframes e9cb74oucte5_tr__tr{0%{transform:rotate(0deg);animation-timing-function:cubic-bezier(.63,.245,.455,.985)}to{transform:rotate(360deg)}}'
                }
            </style>
            <g
                style={{
                    animation:
                        'e9cb74oucte3_to__to 2000ms linear infinite normal forwards'
                }}
                id="prefix__e9cb74oucte2"
            >
                <g
                    transform="translate(125.706 125.414)"
                    style={{
                        animation:
                            'e9cb74oucte3_tr__tr 2000ms linear infinite normal forwards'
                    }}
                >
                    <path
                        id="prefix__e9cb74oucte3"
                        d="M157.1 113.9l12.3 12.3c1.4 1.4 1.4 3.7 0 5.1l-68.7 68.5c-1.4 1.4-1.4 3.6 0 5 .1.1.2.2.4.3 11.3 8.5 27.1 7.4 37.1-2.6l53.7-53.7.1.1 17.6-17.6c1.4-1.4 1.4-3.7 0-5.1L157 73.6c-1.4-1.4-3.7-1.4-5.1 0L118.6 107c-1.4 1.4-1.4 3.7 0 5.1l15.1 15.1c1.4 1.4 3.7 1.4 5.1 0L152 114c1.4-1.5 3.6-1.5 5.1-.1z"
                        transform="translate(-118.415 -127.78)"
                        fill="#FFF"
                        stroke="none"
                        strokeWidth={1}
                    />
                </g>
            </g>
            <g
                style={{
                    animation:
                        'e9cb74oucte5_to__to 2000ms linear infinite normal forwards'
                }}
                id="prefix__e9cb74oucte4"
            >
                <g
                    transform="translate(109.013 122.578)"
                    style={{
                        animation:
                            'e9cb74oucte5_tr__tr 2000ms linear infinite normal forwards'
                    }}
                >
                    <path
                        id="prefix__e9cb74oucte5"
                        d="M77.6 141.6l-12.3-12.3c-1.4-1.4-1.4-3.7 0-5.1L134 55.7c1.4-1.4 1.4-3.6 0-5-.1-.1-.2-.2-.4-.3-11.3-8.5-27.1-7.4-37.1 2.6l-53.7 53.7-.1-.1-17.6 17.6c-1.4 1.4-1.4 3.7 0 5.1l52.5 52.5c1.4 1.4 3.7 1.4 5.1 0l33.3-33.3c1.4-1.4 1.4-3.7 0-5.1l-15-15.1c-1.4-1.4-3.7-1.4-5.1 0l-13.2 13.2c-1.4 1.4-3.7 1.4-5.1.1z"
                        transform="translate(-117 -128.251)"
                        fill="#FFF"
                        stroke="none"
                        strokeWidth={1}
                    />
                </g>
            </g>
        </svg>
    );
};

export default Spinner;
